const config = {
  TOKEN_LOCALSTORAGE_KEY: "irpcid",
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  irpcApiBaseUrl: process.env.REACT_APP_IRPC_API_BASE_URL,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  PUBLIC_URL: process.env.PUBLIC_URL
};

module.exports = config;



// WEBPACK FOOTER //
// ./src/config.js